document.addEventListener('DOMContentLoaded', () =>{

    /* modal launcher buttons */

    const modalLauncherButtons = document.querySelectorAll('.product-card-modal-launcher-button');
    modalLauncherButtons.forEach((button)=>{
        button.addEventListener('click',(e)=>{
            e.preventDefault();
            console.log('click');
            if (window.innerWidth >= 990) {
                e.target.closest('.product').querySelector('.product__info-wrapper').style.display = 'block';
            }
            else {
                e.target.closest('.product').querySelector('.product__info-wrapper').classList.add('open');
            }
            document.querySelector('body').classList.add('overflow-hidden');
        });
    });

    /* modal close */
    const modalCloseButtons = document.querySelectorAll('.quick-buy-modal-close');
    modalCloseButtons.forEach((button)=>{
        button.addEventListener('click', (e)=>{
            e.preventDefault();
            if (window.innerWidth >= 990) {
                e.target.closest('.product__info-wrapper').style.display = 'none';
            }
            else {
                e.target.closest('.product__info-wrapper').classList.remove('open');
            }
            document.querySelector('body').classList.remove('overflow-hidden');
        });
    });
    
    /* mobile modal close */
    const quickBuyModals = document.querySelectorAll('.quick-buy-modal');
    quickBuyModals.forEach((modal)=>{
        modal.addEventListener('mousedown', (e)=>{
            if (window.innerWidth < 990 && !e.target.closest('product-info')) {
                e.target.closest('.product__info-wrapper').classList.remove('open');
                document.querySelector('body').classList.remove('overflow-hidden');
            }
        });
    });

    /* mobile menu close */
    const menuDrawerClose = document.querySelectorAll('.menu-drawer-close');
    const menuSummary = document.querySelector('.header__icon--menu.header__icon--summary');
    menuDrawerClose.forEach((button)=>{
        button.addEventListener('click', (e)=>{
            e.preventDefault();
            console.log('click');
            menuSummary.click();
        });
    });

    // const subMenuLinks = document.querySelectorAll('.header-grandchild-menu .header__menu-item.link ');
    // subMenuLinks.forEach(link => {
    //     link.addEventListener('click', e =>{
    //         console.log('link clicked')            
    //          e.stopPropagation();
    //     })
    // })
});